import { BsPlus } from "react-icons/bs";
import { FiSearch } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const RolesToolbar = ({ setSearchRole }) => {
  const [SearchRole, setSearchRoleState] = useState("");
  const navigate = useNavigate();

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchRoleState(value);
    setSearchRole(value);
  };

  return (
    <div className="flex justify-between items-center mb-4">
      <div className="relative">
        <FiSearch
          size={16}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
        />
        <input
          type="text"
          placeholder="Search roles"
          className="border pl-9 pr-3 py-2 rounded text-sm input-field"
          value={SearchRole}
          maxLength={256}
          onChange={handleSearchChange}
        />
      </div>

      <button className="btn-add px-4" title="Add" onClick={() => navigate("/roles/add")}>
        <BsPlus size={26} color="#ffffff" /> Role
      </button>
    </div>
  );
};

export default RolesToolbar;
